import { auth } from '../../config/firebase';
import { notificarSesionExpirada } from './sessionExpiry';

/**
 * SPEC-175 — RN-008: siempre se pide un idToken fresco (getIdToken gestiona
 * caché/refresco internamente); nunca se cachea el token en la app.
 * Firma compatible con `fetch` para migrar los servicios existentes sin
 * cambiar su lógica de manejo de respuesta/errores.
 */
export async function apiFetch(input: RequestInfo, init: RequestInit = {}): Promise<Response> {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('No hay sesión activa');
  }

  const idToken = await user.getIdToken();

  const response = await fetch(input, {
    ...init,
    headers: {
      ...init.headers,
      Authorization: `Bearer ${idToken}`,
    },
  });

  // SPEC-185 — CA-008: la sesión expira por 8h de inactividad y el backend lo señala en
  // cualquier endpoint. Se inspecciona una COPIA para no consumir el cuerpo que el
  // llamador va a leer, y el aviso no altera la respuesta que se devuelve.
  if (response.status === 401) {
    await avisarSiLaSesionExpiro(response);
  }

  return response;
}

async function avisarSiLaSesionExpiro(response: Response): Promise<void> {
  try {
    const cuerpo = await response.clone().json();
    if (cuerpo?.error?.code === 'SESSION_EXPIRED') {
      notificarSesionExpirada();
    }
  } catch {
    // Un 401 sin cuerpo JSON (p. ej. el "No autenticado" heredado de SPEC-175) no es una
    // expiración de sesión: se deja pasar sin avisar.
  }
}
